import { Button } from '../Button/Button';
import styles from './PrimaryButton.module.css';

interface PrimaryButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    loading?: boolean;
}

const PrimaryButton = ({ className, ...props }: PrimaryButtonProps): React.JSX.Element => (
    <Button className={`${styles.primaryButton}${className ? ` ${className}` : ''}`} {...props} />
);

export { PrimaryButton };
